import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { BaseService } from '@essent/common';
import { firstValueFrom, from, type Observable } from 'rxjs';
import { API_PUBLIC_PREFIX } from '@core/config-angular';
import type {
  PostHeatpumpV1Data,
  PostHeatpumpV1Response,
} from '@integration/api-client/feh';
import type { RequestClient } from '@integration/api-client/client-core';
import { postHeatpumpV1 } from '@integration/api-client/feh/client.gen';

@Injectable()
export class PostHeatpumpsLeadService
  implements BaseService<PostHeatpumpV1Data, PostHeatpumpV1Response>
{
  private readonly apiUrl: string | null = inject(API_PUBLIC_PREFIX, {
    optional: true,
  });
  private readonly httpClient = inject(HttpClient);
  public readonly apiVersion = '1';
  public readonly endpoint = `${this.apiUrl || ''}/feh/leads/heat-pump/v${
    this.apiVersion
  }`;

  private readonly requestClient: RequestClient = {
    makeRequest: async (requestOptions, headers) => {
      return firstValueFrom(
        this.httpClient.post<PostHeatpumpV1Response>(
          this.endpoint,
          requestOptions.body,
          { headers }
        )
      );
    },
  };

  public call$(
    payload: PostHeatpumpV1Data
  ): Observable<PostHeatpumpV1Response> {
    const headers = { Accept: 'application/json', Brand: 'essent' };
    return from(postHeatpumpV1(payload, this.requestClient, headers));
  }
}
